import React, { useState } from 'react';
import './CurrencyForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

function CurrencyForm({ initial, onSave, onCancel, loading }) {
  const [currency_code, setCurrencyCode] = useState(initial?.currency_code || '');
  const [currency_name, setCurrencyName] = useState(initial?.currency_name || '');
  const [error, setError] = useState('');

  const validate = () => {
    if (!currency_code.trim()) return 'Currency code is required.';
    if (!/^[A-Z]{3}$/.test(currency_code.trim())) return 'Currency code must be exactly 3 uppercase letters.';
    if (!currency_name.trim()) return 'Currency name is required.';
    return '';
  };

  const handleSubmit = e => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      currency_code: currency_code.trim().toUpperCase(),
      currency_name: currency_name.trim().replace(/\s+/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
    });
  };

  return (
    <form className="currency-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div>
        <label>Currency Code<RequiredMark /></label><br />
        <input
          className="styled-input"
          value={currency_code}
          onChange={e => setCurrencyCode(e.target.value.toUpperCase().slice(0, 3))}
          maxLength={3}
          placeholder="e.g., AUD"
        />
      </div>
      <div>
        <label>Currency Name<RequiredMark /></label><br />
        <input
          className="styled-input"
          value={currency_name}
          onChange={e => setCurrencyName(e.target.value)}
          maxLength={100}
          placeholder="e.g., Australian Dollar"
        />
      </div>
      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default CurrencyForm;
